<template>
  <div class="card-review">
    <img
      :src="item.img"
      alt=""
      class="card-review__img"
      draggable="false"
    />
    <div class="card-review__body">
      <div class="body__header">
        <img
          :src="item.imgBeforeTitle"
          alt=""
          class="title-before"
          draggable="false"
        />
        <div class="title">{{ $t(item.title) }}</div>
        <div class="grade">
          <div
            v-for="(star, index) in getArrayItems(item.stars)"
            :key="index"
            :style="getPercentFilledGrade(index, item.stars, `16`)"
          >
            <SvgStarSvg
              :percentFilled="100"
              width="16px"
              height="16px"
            />
          </div>
        </div>
      </div>
      <div class="subtitle">{{ $t(item.subtitle) }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useBaseStore} from '~/modules/BaseModule/base.store';
import {useDirectionStore} from '~/store/direction.store';
import {useI18n} from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    item: {
      id: number;
      img: string;
      imgBeforeTitle: string;
      title: string;
      stars: number | string;
      subtitle: string;
    };
  }>(),
  {},
);

const {t} = useI18n();

const getPercentFilledGrade = (
  index: number,
  grade: number | string,
  itemSize: string,
) => {
  const currentGrade = typeof grade === 'string' ? t(grade) : grade;
  const currentValue = Number(currentGrade) - (index + 1);
  const maxWidth = (1 - Math.abs(currentValue)) * Number(itemSize);

  if (currentValue >= 0) {
    return `max-width: ${itemSize}px; overflow: hidden`;
  }
  return `max-width: ${maxWidth}px; overflow: hidden`;
};

const getArrayItems = (grade: string | number) => {
  const currentGrade = typeof grade === 'string' ? t(grade) : grade;

  const result = Math.ceil(Number(currentGrade));
  return result;
};
</script>

<style scoped lang="scss">
.card-review {
  display: flex;
  flex-direction: column;
  border-radius: $br-6;
  box-shadow: 0px 0px 20px #18191a29;

  &__img {
    border-top-right-radius: $br-6;
    border-top-left-radius: $br-6;
  }
  &__body {
    display: flex;
    flex-direction: column;
    gap: $g-4;
    padding: $p-6;

    .body__header {
      display: grid;
      grid-template-columns: min-content 1fr;
      grid-row: 1fr 1fr;
      align-items: center;
      column-gap: $g-3;
      row-gap: $g-1;
      .title-before {
        grid-row: 1/3;
        height: 48px;
        width: 48px;
        border-radius: 50%;
      }
      .title {
        @include launcher-p1;
        color: var(--var-black-100);
        grid-row: 1/1;
        grid-column: 2/3;
        display: flex;
        width: max-content;
      }

      .grade {
        width: 100%;
        display: flex;
        gap: $g-2;
        grid-column: 2/3;
        grid-row: 2/3;
        @media (max-width: 1100px) {
          gap: $g-1;
        }
      }
    }
  }
}
</style>
